import { render, staticRenderFns } from "./FixedButton.vue?vue&type=template&id=d4dc488a&scoped=true&"
import script from "./FixedButton.vue?vue&type=script&lang=js&"
export * from "./FixedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc488a",
  null
  
)

export default component.exports